<template>
  <div>
    <v-list-tile @click="showDetails">
      <v-layout align-center row class="caption py-2" wrap
        :class="paddingClass"
      >
        <ListIcon>
          <v-icon
            color="primary"
          >
            folder
          </v-icon>
        </ListIcon>
        <v-flex xs10 sm5 md7>
          {{item.name}}
        </v-flex>
        <v-flex xs6 sm3 md2>
          {{item.space_used}} z {{item.space_available}}
        </v-flex>
        <v-flex xs6 sm3 md2>
          <v-tooltip top>
            <v-progress-linear
              slot="activator"
              color="primary"
              height="6"
              :value="item.space_used_percent"
            ></v-progress-linear>
            <span>Wykorzystywane miejsce: {{item.space_used_percent}}%</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-divider v-if="!isLast"></v-divider>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ListIcon from './../common/ListIcon.vue';

export default {
  name: 'dashboard-item',
  props: ['item', 'index'],
  components: {
    ListIcon,
  },
  computed: {
    ...mapGetters('dashboard-admin', [
      'itemsList',
    ]),
    isLast() {
      return this.itemsList.length - 1 === this.index;
    },
    paddingClass() {
      return this.$vuetify.breakpoint.smAndDown ? 'px-0' : 'px-2';
    },
  },
  methods: {
    showDetails() {
      this.$router.push(`/klient/${this.item.client_id}`);
    },
  },
};
</script>

<style scoped>
  .user_item {
    position: relative;
  }
</style>
